var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col lg:flex-row lg:space-x-6"},[_c('div',{staticClass:"order-2 flex flex-1 flex-col lg:order-1"},[_vm._t("content")],2),_c('aside',{staticClass:"order-1 flex w-full flex-shrink-0 flex-col lg:order-2 lg:w-96"},[_vm._t("sidebar")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }